export default __webpack_public_path__ + "static/media/Calendario.ab21474c.svg";